const queryParams = new URLSearchParams(window.location.search);
const runMode = queryParams.get("mode");

export default function JumpScene3() {
  return <>{runMode === "play" && <div></div>}</>;
}
